import { Button, Carousel, Modal } from 'antd';
import receipt1 from '../../images/Haleon/receiptSample.png';
import shopeeReceipt from '../../images/Haleon/shopee-invoice.png';
import lazadaReceipt from '../../images/Haleon/lazada-invoice.png';
import '../../css/UploadReceipt.css';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

const SampleReceipt = ({ uploadSample, setUploadSample }) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const isSGRegion = window.location.hostname.replace('www.', '') === process.env.REACT_APP_SG_DOMAIN;
	const { t } = useTranslation();

	//* Any sample receipt can be added here
	const sampleReceipts = [
		{
			src: receipt1,
			desc: `${t("Sample of physical receipt")}:`,
			alt: 'Sample_Receipt1',
		},
		// {
		// 	src: receipt2,
		// 	desc: `${t("Sample of e-commerce receipt")}:`,
		// 	alt: 'Sample_Receipt2',
		// },
		{
			src: lazadaReceipt,
			desc: `(${t("Lazada Invoice")})`,
			alt: 'Lazada_Receipt',
			myInvoiceLink: 'https://helpcenter.lazada.com.my/s/faq/knowledge?categoryId=101399197&m_station=faq&questionId=k0200000000000000000000000000am9',
			sgInvoiceLink: 'https://helpcenter.lazada.sg/s/faq/knowledge?categoryId=101399197&m_station=BuyerHelp&questionId=k0200000000000000000000000000ama&terminal=pc'
		},
		{
			src: shopeeReceipt,
			desc: `(${t("Shopee Invoice")})`,
			alt: 'Shopee_Receipt',
			myInvoiceLink: "https://help.shopee.com.my/portal/4/article/160220-%5BNew-to-Shopee%5D-How-to-generate-my-order's-E-Invoice",
			sgInvoiceLink: 'https://help.shopee.sg/portal/4/article/116666'
		},
	]


	return (
		<div>
			<Modal
				open={uploadSample}
				centered
				footer={null}
				header={null}
				width={320}
				// bodyStyle={{height: 380}}
				// className="receipt-sample-modal"
				onCancel={() => setUploadSample(false)}
				closable={{ style: { backgroundColor: 'red' } }}
			>
				<div className="receipt-sample-modal">
					{/* <Carousel>
						<div className="text-center">
							<h2 className='font-family-hero-new fontSize-25 font-weight-600'>{t('Receipt Sample')}</h2>
							<div className="mt-1 text-center font-family-hero-new fontSize-16">
								{t('Sample of physical receipt')}:
							</div>
							<img src={receipt1} alt="purchase" className="w-100" />
						</div>

						<div>
							<h2 className="text-center font-family-hero-new fontSize-25 font-weight-600">{t('Receipt Sample')}</h2>
							<div className="mt-1 text-center font-family-hero-new fontSize-16">
								{t('Sample of e-commerce receipt')}:
							</div>
							<img
								src={receipt2}
								alt="Sample_Receipt2"
								style={{
									objectFit: 'contain',
									width: '50%',
									textAlign: 'center',
									display: 'block',
									justifyContent: 'center',
									margin: 'auto',
								}}
							/>
						</div>
					</Carousel> */}
					<Carousel afterChange={(index) => setCurrentSlide(index)} style={{position: 'relative'}}>
						{sampleReceipts.map((receipt) => (
							<div style={{position: 'absolute'}}>
								<h2 className="text-center font-family-hero-new fontSize-25 font-weight-600">{t('Receipt Sample')}</h2>
								<p className='text-center mt-1'>{receipt.desc}</p>
								<img
									src={receipt.src}
									alt={receipt.alt}
									style={{
										margin: '25px 0',
										objectFit: 'contain',
										height: '250px',
										width: '100%',
									}}
								/>
							</div>
						))}
					</Carousel>
					{sampleReceipts[currentSlide].myInvoiceLink && (
						<Button target='_blank' style={{background: '#30e700' ,color: 'black', width: '100%', borderRadius: '8px', fontWeight: 500, outline: 'none'}} className="mt-2" href={isSGRegion ? sampleReceipts[currentSlide].sgInvoiceLink : sampleReceipts[currentSlide].myInvoiceLink}>
							{t("How to download invoice?")}
						</Button>
					)}
				</div>
			</Modal>
		</div>
	);
};

export default SampleReceipt;
